import { PageNav, NavTab } from "@ugg/shared/components/common/PageNav";
import { AppRoutes } from "@ugg/shared/routes/app-routes";
import { useActiveSpecialModes, SPECIAL_GAME_MODES } from "@ugg/shared/utils/special-game-modes";
import { tierListPageUrls } from "@ugg/shared/pages/tier-list-pages";

export function TierListPageNav({ className }: { className?: string }) {
  const activeModes = useActiveSpecialModes({ ssr: true });

  const specialModeTabs: NavTab[] = activeModes.map((mode) => {
    const { tierListPageName, tierListSettings, newTag } = SPECIAL_GAME_MODES[mode];
    return {
      to: tierListPageUrls[tierListPageName],
      label: tierListSettings.title.main,
      reset: true,
    };
  });

  const tabs: NavTab[] = [
    {
      to: AppRoutes.DEFAULT_TIER_LIST,
      label: "Tier List",
      activePaths: [
        AppRoutes.TOP_TIER_LIST,
        AppRoutes.JUNGLE_TIER_LIST,
        AppRoutes.MID_TIER_LIST,
        AppRoutes.ADC_TIER_LIST,
        AppRoutes.SUPPORT_TIER_LIST,
      ],
    },
    ...specialModeTabs,
    ...(process.env.UGG_PUBLIC_PLATFORM !== "app"
      ? [{ to: AppRoutes.ARAM_MAYHEM_AUGMENT_TIER_LIST, label: "ARAM Mayhem Augment Tier List" }] // TODO: app check not ran for aram mayhem now since it's in specialModeTabs
      : []),
    { to: AppRoutes.DUO_TIER_LIST, label: "Duo Tier List" },
    { to: AppRoutes.COMBAT_TIER_LIST, label: "Combat" },
    { to: AppRoutes.OBJECTIVES_TIER_LIST, label: "Objectives" },
  ];

  return <PageNav className={className} tabs={tabs} />;
}
